import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { ProfessionalService } from '../../../shared/services/professional.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogHistoryProfessionalComponent } from '../dialog-history-professional/dialog-history-professional.component';
import { DialogChangePasswordProfessionalComponent } from '../dialog-change-password-professional/dialog-change-password-professional.component';
import { ModalFileComponent } from '../edit-professional/modal-file/modal-file.component';
import { ModalPdfViewerComponent } from 'src/app/shared/components/modal-pdf-viewer/modal-pdf-viewer.component';
import { FileService } from '../../../shared/services/file.service';

export interface IProfessionals {
  id: string;
  _id: string;
  name: string;
  fullname: string;
  image: string;
  cellphone: string;
  email: string;
  dateOfBirth: string;
  address: string;
  isChecked: boolean;
  isBlocked: boolean;
}

@Component({
  selector: 'app-list-professionals-contracts',
  templateUrl: './list-professionals-contracts.component.html',
  styleUrls: ['./list-professionals-contracts.component.scss'],
})
export class ListProfessionalsContractsComponent implements OnInit {
  displayedColumns: string[] = [
    'name',
    'email',
    'licenseNumber',
    'action',
  ];

  dataSource: MatTableDataSource<IProfessionals>;

  constructor(
    private professionalService: ProfessionalService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private fileService: FileService
  ) {}

  ngOnInit() {
    this.getAll();
  }

  viewHistory(professionalId: string, name: string) {
    this.dialog.open(DialogHistoryProfessionalComponent, { data: {professionalId, name} });
  }

  getAll() {
    this.professionalService.getAllWithContracts().subscribe((result: any) => {

      const professionals = result.map((professional: any, index: number) => ({
        id: professional.professionalId,
        name: professional.fullname,
        email: professional.email,
        licenseNumber: professional.licenseNumber,
        action: 'ri-more-fill',
        contractFile: professional.contractFile
      }));
      this.dataSource = new MatTableDataSource<IProfessionals>(professionals);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  getNameStatus(status: string) {
    switch(status) {
      case 'APPROVED':
        return 'Aprovado';
      case 'REJECTED':
        return 'Rejeitado';
      case 'PENDING_UPLOAD':
        return 'Aguardando envio';
      case 'PENDING':
      default:
        return 'Pendente de análise';
    }
  }

  openDialog(fileId: string, field: string, description: string, title: string, professionalId: string): void {
    const dialogRef = this.dialog.open(ModalFileComponent, {
      data: { fileId, field, description, title, professionalId },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getAll();
    });
  }

  downloadFile(fileId: string, mimetype: string, filename: string, fullname: string) {
    this.fileService.download(fileId, mimetype, `${fullname}-${filename}`).subscribe(
      () => this.snackbar.open('Concluido', 'OK', { duration: 300 }),
      () =>
        this.snackbar.open('Nao foi possivel baixar o arquivo', 'OK', {
          duration: 3000,
        })
    );
  }

  checkFile(fileId: string, status: string) {
    this.fileService.check(status, fileId).subscribe(
      () => {
        this.snackbar.open('Atualizado com sucesso', 'OK', { duration: 6000 });
      },
      () =>
        this.snackbar.open(
          'Nao foi possivel validar o arquivo, tente novamente mais tarde!',
          'OK',
          {
            duration: 3000,
          }
        )
    );
  }

  viewFileDialog(fileId: string, mimetype: string, professionalId: string): void {
    const maxWidth = window.innerWidth * 0.8;
    const maxHeight = window.innerHeight * 0.85;

    const dialogRef = this.dialog.open(ModalPdfViewerComponent, {
      data: { fileId, mimetype, professionalId },
      maxWidth: `${maxWidth}px`,
      maxHeight: `${maxHeight}px`,
      height: 'auto',
      width: 'auto',
      panelClass: 'document-viewer-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('The dialog was closed');
    });
  }

  convertSize(bytes: number, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }

    const units = si
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10 ** dp;

    do {
      bytes /= thresh;
      ++u;
    } while (
      Math.round(Math.abs(bytes) * r) / r >= thresh &&
      u < units.length - 1
    );

    return bytes.toFixed(dp) + ' ' + units[u];
  }
}
